export default __webpack_public_path__ + "71403889fbcc09fd1433b55c73254d74.svg";